(function () {
  const sectionSelector = '[data-corridge-review-carousel]';

  function formatDate(value) {
    if (!value) return '';

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat(document.documentElement.lang || 'de', {
      month: 'long',
      year: 'numeric',
    }).format(date);
  }

  function getReviewMeta(review) {
    if (!review) return '';

    const location =
      review.reviewer_location ||
      review.location ||
      review.city ||
      review.country_name ||
      '';
    const date = formatDate(
      review.created_at || review.reviewed_at || review.submitted_at || review.review_date,
    );

    return [location, date].filter(Boolean).join(' · ');
  }

  function enhanceCard(card, reviews) {
    const reviewerInfo = card.querySelector('.jdgm-reviewer-info');
    const reviewerName = reviewerInfo?.querySelector('.jdgm-reviewer-name');

    if (!reviewerInfo || !reviewerName || reviewerInfo.dataset.corridgeEnhanced === 'true') {
      return;
    }

    const cardIndex = Number.parseInt(card.dataset.cardIndex || '', 10);
    const review = Number.isNaN(cardIndex) ? null : reviews[cardIndex];
    const reviewerCopy = document.createElement('span');
    const meta = document.createElement('span');
    const avatar = document.createElement('span');
    const reviewerText = reviewerName.textContent.trim();

    reviewerCopy.className = 'corridge-reviewer-copy';
    meta.className = 'corridge-review-meta';
    meta.textContent = getReviewMeta(review);
    avatar.className = 'corridge-review-avatar';
    avatar.textContent = reviewerText.charAt(0).toLocaleUpperCase() || 'C';
    avatar.setAttribute('aria-hidden', 'true');

    reviewerCopy.append(reviewerName, meta);
    reviewerInfo.prepend(reviewerCopy);
    reviewerInfo.append(avatar);
    reviewerInfo.dataset.corridgeEnhanced = 'true';

    const clickEnabled =
      card.closest('[data-review-card-click-enabled]')?.dataset.reviewCardClickEnabled !== 'false';

    if (clickEnabled) {
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      const openReviewLabel = window.themeVariables?.strings?.corridgeOpenReview || 'Bewertung von [name] öffnen';
      card.setAttribute('aria-label', openReviewLabel.replaceAll('[name]', reviewerText));

      card.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        card.click();
      });
    }
  }

  function enhanceCarousel(carousel) {
    const blockId = carousel.dataset.jdgmBlockId;
    const reviews =
      (blockId && window.jdgmCarouselMode && window.jdgmCarouselMode[blockId]?.reviews) || [];

    carousel.querySelectorAll('.jdgm-media-card').forEach((card) => enhanceCard(card, reviews));
  }

  function init() {
    const sections = document.querySelectorAll(sectionSelector);
    if (!sections.length) return;

    sections.forEach((section) => {
      section.addEventListener(
        'click',
        (event) => {
          if (
            section.dataset.reviewCardClickEnabled === 'false' &&
            event.target.closest('.jdgm-media-card')
          ) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        },
        true,
      );

      const enhance = () => {
        section.querySelectorAll('.jdgm-cards-carousel').forEach(enhanceCarousel);
      };

      enhance();
      new MutationObserver(enhance).observe(section, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
